/**
 * VISIBILITY CUSTOM ELEMENT
 * Abstracted from several other components that handle toggling state. Created for DRYness.
 */

export class VisibilityElement extends HTMLElement {
  handleShow: () => void
  handleHide: () => void
  handleToggle: () => void
  handleDisable: () => void
  handleEventDisable: (event: any) => void
  handleEventShow: (event: any) => void
  handleEventHide: (event: any) => void

  constructor() {
    super()

    // CUSTOM METHODS
    // Adding custom methods here to deal with 'this' issues

    this.handleShow = () => {
      this.dataset.ui = 'visible'
    }

    this.handleHide = () => {
      this.dataset.ui = undefined
    }

    this.handleDisable = () => {
      this.dataset.ui = 'disabled'
    }

    this.handleToggle = () => {
      if (this.dataset.ui === 'visible') this.handleHide()
      else this.handleShow()
    }

    this.handleEventShow = (event) => {
      if (event.detail.target !== this.dataset.id) return
      this.handleShow()
    }

    this.handleEventHide = (event) => {
      if (event.detail.target !== this.dataset.id) return
      this.handleHide()
    }

    this.handleEventDisable = (event) => {
      if (event.detail.target !== this.dataset.id) return
      this.handleDisable()
    }
  }

  // Event Dispatchers
  static EVENT_SHOW = 'show'
  static dispatchShow(id: string) {
    document.dispatchEvent(
      new CustomEvent(VisibilityElement.EVENT_SHOW, {
        detail: {
          target: id
        }
      })
    )
  }

  static EVENT_HIDE = 'hide'
  static dispatchHide(id: string) {
    document.dispatchEvent(
      new CustomEvent(VisibilityElement.EVENT_HIDE, {
        detail: {
          target: id
        }
      })
    )
  }

  static EVENT_DISABLE = 'disable'
  static dispatchDisable(id: string) {
    document.dispatchEvent(
      new CustomEvent(VisibilityElement.EVENT_DISABLE, {
        detail: {
          target: id
        }
      })
    )
  }

  addEventListeners() {
    document.addEventListener(VisibilityElement.EVENT_SHOW, this.handleEventShow.bind(this))
    document.addEventListener(VisibilityElement.EVENT_HIDE, this.handleEventHide.bind(this))
    document.addEventListener(VisibilityElement.EVENT_DISABLE, this.handleEventDisable.bind(this))
  }

  removeEventListeners() {
    document.removeEventListener(VisibilityElement.EVENT_SHOW, this.handleEventShow.bind(this))
    document.removeEventListener(VisibilityElement.EVENT_HIDE, this.handleEventHide.bind(this))
    document.removeEventListener(VisibilityElement.EVENT_DISABLE, this.handleEventDisable.bind(this))
  }

  connectedCallback() {
    this.addEventListeners()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }
}
